import React, { useEffect, useState } from "react";
import { AddHeader } from "../../components/AddHeader";
import { AddGroup } from "../../components/AdminLayout/AddGroup";
import {
  allclublist,
} from "../../components/funtionsBD/Mainservice";
import { t } from "i18next";

export const CreateGroup = () => {
  const [club, setclub] = useState([]);

  useEffect(() => {
    getclub();
  }, []);

  const getclub = async () => {
    try {
      const response = await allclublist();
      setclub(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div id="adminRoot" className="group-form-theme">
        <AddHeader title={t("addgroup")} />
        <AddGroup club={club} />
      </div>
    </>
  );
};
